import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type AlertLevel = 'info' | 'warning' | 'error' | 'success' | 'ok';

@Component({
  selector: 'hdis-alert-message',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './hdis-alert-message.component.html',
  styleUrls: ['./hdis-alert-message.component.scss'],
})
export class HdisAlertMessageComponent {
  @Input() level: AlertLevel = 'info';
  @Input() icon?: string;

  get alertClass(): string {
    return `${this.level}-alert`;
  }

  get defaultIcon(): string {
    if (this.icon) {
      return this.icon;
    }

    switch (this.level) {
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      case 'error':
        return 'error';
      case 'success':
        return 'check_circle';
      case 'ok':
        return 'check_circle';
      default:
        return 'info';
    }
  }
}
